import React, { useRef, useState, useEffect } from 'react';
import {
   Box,
   Button,
   Grid,
   IconButton,
   Paper,
   Typography,
   Backdrop,
   Chip,
   Switch,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/pro-light-svg-icons/faTimesCircle';
import { AlertLabel, Input, TextArea } from '../../../assets/styled/Element';
import { Controller, useForm } from 'react-hook-form';
import Axios from 'axios';
import LoadingPopup from '../../Loading/LoadingPopup';
import ErrorPopup from '../../Error/ErrorPopup';
import { useSnackbar } from 'notistack';
import { TitleLabel } from '../../Element/LabelInputForm';
import { reverseFormatNumber } from '../../../configs/helpers/utility';
import { LogToBackend } from '../../../configs/helpers/LogToBackend';
import SearchEmployee from '../../Search/SearchEmployee';
import MaterialTable from 'material-table';
import {
   headerStyle,
   tableIcons,
   tableStyle,
} from '../../../configs/ui/TableConfig';

const constant = {
   newEmployee: 1,
   alreadyHavePermission: 2,
};

const useStyles = makeStyles((theme) => ({
   backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
   },
   paper: {
      padding: theme.spacing(2, 4, 3),
      width: '750px',
      borderRadius: '7.5px',
      maxHeight: '95vh',
      overflow: 'auto',
   },
   role: {
      color: '#5858FA',
   },
   title: {
      color: '#6E6E6E',
   },
   large: {
      width: theme.spacing(8),
      height: theme.spacing(8),
   },
   header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignContent: 'center',
      alignItems: 'center',
      margin: theme.spacing(1, 0),
   },
   content: {
      margin: theme.spacing(0, 1),
      width: '100%',
   },
   headerL: {
      margin: theme.spacing(1),
   },
   listStyle: {
      height: '65px',
   },
   flexGrid: {
      display: 'flex',
      alignItems: 'center',
   },
   qrPaper: {
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      height: '100%',
      width: '100%',
   },
   detailRight: {
      height: '280px',
      overflow: 'auto',
   },
}));

const columnsA = [
   {
      field: 'orgEmployeeId',
      title: 'รหัสพนักงาน',
      width: 150,
      editable: 'never',
   },
   {
      field: 'nameTh',
      title: 'ชื่อ-นามสกุล',
   },
   {
      field: 'divisionName',
      title: 'สังกัด',
   },
];

const Edit = (props) => {
   const classes = useStyles();
   const [isLoading, setIsLoading] = useState(false);
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   const [innerTableData, setInnerTableData] = useState([]);
   const [selected, setSelected] = useState(null);
   const [isError, setIsError] = useState({
      error: false,
      errorStatus: '',
      errorMessage: '',
   });
   const closeRef = useRef();
   const {
      handleSubmit,
      control,
      register,
      errors,
      watch,
      setValue,
      getValues,
   } = useForm({});

   useEffect(() => {
      let permissionEmployeeList = props.data.permissionEmployeeList.map(
         (el) => {
            return {
               ...el,
               action: constant.alreadyHavePermission,
            };
         },
      );
      setValue('nameGroup', props.data.permissionGroupNameTh);
      setInnerTableData(permissionEmployeeList);
   }, [props.data]);

   const isNotActiveOnOtherGroup = (params) => {
      return Axios.post('/GSB/dashboard/permission/ValidateAdmin', null, {
         params: params,
      })
         .then((resp) => {
            return resp.data;
         })
         .catch((e) => {
            if (e.response) {
               const response = e.response.data;
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
            return false;
         });
   };

   const onToggleActive = (rowData) => async () => {
      let index = innerTableData.findIndex(
         (el) => rowData.orgEmployeeId === el.orgEmployeeId,
      );
      let obj = innerTableData[index];
      let payload = {
         actionId: 2,
         permissionGroupId: props.data.permissionGroupId,
         orgEmployeeId: rowData.orgEmployeeId,
         isEnable: !rowData.isActive,
      };
      if (await isNotActiveOnOtherGroup(payload)) {
         obj.isActive = !obj.isActive;
         setInnerTableData([
            ...innerTableData.slice(0, index),
            obj,
            ...innerTableData.slice(index + 1),
         ]);
      }
   };

   const onSubmit = (e) => {
      setIsLoading(true);
      let payload = {
         permissionGroupId: props.data.permissionGroupId,
         groupName: e.nameGroup,
         employees: innerTableData.map((el) => {
            return {
               orgEmployeeId: el.orgEmployeeId,
               isEnable: el.isActive,
               action: el.action,
            };
         }),
      };
      Axios.post('/GSB/dashboard/permission/AdjustPermissionGroup', payload)
         .then(() => {
            enqueueSnackbar(`แก้ไขกลุ่มผู้ใช้งาน "${e.nameGroup}" สำเร็จ`, {
               variant: 'success',
            });
            props.onSuccess();
         })
         .catch((e) => {
            if (e.response) {
               const response = e.response.data;
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         })
         .finally(() => {
            setIsLoading(false);
         });
   };

   const handleSelect = (e) => {
      if (e) {
         setSelected(e);
      } else {
         setSelected(null);
      }
   };

   const onAddEmployee = async () => {
      if (selected) {
         // const isExist = innerTableData.find(el => selected.data.employeeId === el.orgEmployeeId)
         let payload = {
            actionId: 1,
            permissionGroupId: props.data.permissionGroupId,
            orgEmployeeId: selected.data.employeeId,
            isEnable: true,
         };
         const isNotFoundInOtherGroup = await isNotActiveOnOtherGroup(payload);
         if (isNotFoundInOtherGroup) {
            let formatted = {
               orgEmployeeId: selected.data.employeeId,
               nameTh: selected.data.displayName,
               nameEn: selected.data.description,
               divisionName: selected.data.streetAddress,
               isActive: true,
               action: constant.newEmployee,
            };
            setInnerTableData([formatted, ...innerTableData]);
            setSelected(null);
         }
      }
   };

   if (isError.error)
      return (
         <ErrorPopup
            onClick={props.onClickClose}
            errorStatus={isError.errorStatus}
            errorMessage={isError.errorMessage}
         />
      );
   return (
      <form onSubmit={handleSubmit(onSubmit)}>
         <Paper className={classes.paper}>
            <Backdrop className={classes.backdrop} open={isLoading}>
               <LoadingPopup />
            </Backdrop>
            <div className={classes.header}>
               <div> </div>
               <IconButton
                  className={classes.headerL}
                  size={'small'}
                  onClick={props.onClickClose}
                  ref={closeRef}
               >
                  <FontAwesomeIcon icon={faTimesCircle} />
               </IconButton>
            </div>
            <Box
               display={'flex'}
               alignItems={'flex-start'}
               flexDirection={'column'}
               fontSize={20}
            >
               <Box width={1}>
                  <Box>
                     <Typography variant={'h5'}>จัดการกลุ่ม</Typography>
                     {(errors.nameGroup || errors.nameGroup) && (
                        <AlertLabel>กรุณาระบุชื่อกลุ่ม</AlertLabel>
                     )}
                     <Input
                        name={'nameGroup'}
                        placeholder={'ชื่อกลุ่ม'}
                        ref={register({ required: true })}
                        disabled={!props.data.isCanEditName}
                     />
                  </Box>
                  <Box>
                     <Typography variant={'h5'}>ค้นหารายชื่อ</Typography>
                     <Typography>ค้นหารายชื่อ</Typography>
                     <SearchEmployee
                        value={selected}
                        onChange={handleSelect}
                        menuPortalTarget={document.querySelector('body')}
                     />
                  </Box>
                  <Box>
                     <Typography>สังกัด</Typography>
                     <Box>
                        <Input
                           name={'division'}
                           placeholder={'สังกัด'}
                           disabled
                           value={selected ? selected.data.department : ''}
                        />
                     </Box>
                  </Box>
                  <Box mt={3}>
                     <Box>
                        <Button
                           variant={'contained'}
                           color={'primary'}
                           onClick={onAddEmployee}
                        >
                           เพิ่มรายชื่อ
                        </Button>
                     </Box>
                  </Box>
               </Box>
               <Box width={1} mt={3}>
                  <Box>
                     <MaterialTable
                        // isLoading={isLoading}
                        columns={columnsA}
                        data={innerTableData}
                        options={{
                           // selection: true,
                           showTitle: false,
                           headerStyle: headerStyle,
                           actionsColumnIndex: -1,
                           addRowPosition: 'first',
                           actionsCellStyle: {
                              color: '#ccc',
                           },
                           padding: 'dense',
                           search: false,
                           toolbar: false,
                        }}
                        localization={{
                           body: {
                              editRow: {
                                 deleteText: 'ต้องการลบข้อมูลนี้ใช่หรือไม่?',
                              },
                           },
                           header: { actions: 'ตัวจัดการ' },
                        }}
                        style={tableStyle}
                        icons={tableIcons}
                        actions={[
                           (rowData) => ({
                              icon: React.forwardRef((props, ref) => (
                                 <Switch
                                    onChange={onToggleActive(rowData)}
                                    ref={ref}
                                    {...props}
                                    checked={rowData.isActive}
                                    inputProps={{
                                       'aria-label': 'secondary checkbox',
                                    }}
                                 />
                              )),
                              tooltip: rowData.isMapped
                                 ? 'Is Active'
                                 : 'No Active',
                              // onClick: (event, rowData) => UpdateItemCategory(rowData),
                           }),
                        ]}
                     />
                  </Box>
               </Box>
               <Box mt={3}>
                  <Box>
                     <Button
                        variant={'contained'}
                        color={'primary'}
                        type={'submit'}
                     >
                        ยืนยัน
                     </Button>
                     <Button variant={'contained'} onClick={props.onClickClose}>
                        ยกเลิก
                     </Button>
                  </Box>
               </Box>
            </Box>
         </Paper>
      </form>
   );
};

export default Edit;
